import React from "react";
import {
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  DatePicker,
  Select,
  Space,
  Switch,
} from "antd";
import TinyMCEEditor from "../../components/TinyMCEEditor";
import { JobModalProps } from "../../types/job";

const { Option } = Select;

const JobModal: React.FC<JobModalProps> = ({
  visible,
  form,
  onFinish,
  onCancel,
  editingRecord,
  departments = [],
}) => {
  const handleEditorChange = (content: string, key: string) => {
    form.setFieldsValue({ [key]: content });
  };

  return (
    <Modal
      title={editingRecord ? "Chỉnh sửa việc làm" : "Thêm mới việc làm"}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="title"
          label="Vị trí"
          rules={[{ required: true, message: "Vị trí không được để trống" }]}
        >
          <Input placeholder="Vị trí" />
        </Form.Item>

        <Form.Item
          name="location"
          label="Địa điểm"
          rules={[{ required: true, message: "Địa điểm không được để trống" }]}
        >
          <Input placeholder="Địa điểm" />
        </Form.Item>

        <Form.Item label="Mức lương">
          <Input.Group compact>
            <Form.Item
              name={["salary", "amount"]}
              noStyle
            >
              <Input
                style={{ width: "70%" }}
                type="number"
                min={0}
                placeholder="Số tiền"
              />
            </Form.Item>
            <Form.Item
              name={["salary", "unit"]}
              noStyle
            >
              <Select style={{ width: "30%" }} placeholder="Đơn vị">
                <Select.Option value="VND">VND</Select.Option>
                <Select.Option value="$">$</Select.Option>
              </Select>
            </Form.Item>
          </Input.Group>
        </Form.Item>

        <Form.Item name="minSalary" label="Lương tối thiểu">
          <InputNumber
            style={{ width: "100%" }}
            min={1}
            precision={0}
            placeholder="Lương tối thiểu"
          />
        </Form.Item>

        <Form.Item
          name="expiredAt"
          label="Ngày hết hạn"
          rules={[
            { required: true, message: "Ngày hết hạn không được để trống" },
          ]}
        >
          <DatePicker style={{ width: "100%" }} placeholder="Ngày hết hạn" />
        </Form.Item>

        <Form.Item
          name="candidatesNumber"
          label="Số lượng"
          rules={[
            {
              required: true,
              message: "Số lượng không được để trống",
            },
          ]}
        >
          <Input type="number" min={1} placeholder="Số lượng" />
        </Form.Item>

        <Form.Item
          name="departmentId"
          label="Phòng ban"
          rules={[{ required: true, message: "Phòng ban không được để trống" }]}
        >
          <Select placeholder="Phòng ban">
            {departments.map((dept) => (
              <Option key={dept.id} value={dept.id}>
                {dept.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="published"
          label="Trạng thái"
          initialValue={editingRecord?.published || true}
        >
          <Switch defaultChecked />
        </Form.Item>

        <Form.Item
          name="responsibility"
          label="Responsibilities"
          rules={[
            { required: true, message: "Responsibilities không được để trống" },
          ]}
        >
          <TinyMCEEditor
            apiKey={process.env.REACT_APP_EDITOR_KEY}
            initialValue={editingRecord?.responsibility || ""}
            onChange={(content) =>
              handleEditorChange(content, "responsibility")
            }
            height={300}
            placeholder="Responsibilities"
            type="job"
          />
        </Form.Item>

        <Form.Item
          name="requirements"
          label="Requirements"
          rules={[{ required: true, message: "Requirements không được để trống" }]}
        >
          <TinyMCEEditor
            apiKey={process.env.REACT_APP_EDITOR_KEY}
            initialValue={editingRecord?.requirements || ""}
            onChange={(content) => handleEditorChange(content, "requirements")}
            height={300}
            placeholder="Requirements"
            type="job"
          />
        </Form.Item>

        <Form.Item
          name="whyJoinUs"
          label="Why join us?"
          rules={[
            {
              required: true,
              message: "Why join us? không được để trống",
            },
          ]}
        >
          <TinyMCEEditor
            apiKey={process.env.REACT_APP_EDITOR_KEY}
            initialValue={editingRecord?.whyJoinUs || ""}
            onChange={(content) => handleEditorChange(content, "whyJoinUs")}
            height={300}
            placeholder="Why join us?"
            type="job"
          />
        </Form.Item>

        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit">
              Lưu
            </Button>
            <Button onClick={onCancel}>Huỷ</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default JobModal;
